import { Chip } from "@mui/material";
import { findStatusConfig } from "../../constant";

const StatusBadge = ({ status, sx = {} }) => {
  const config = findStatusConfig(status);

  if (!config) return null;

  return (
    <Chip
      label={config.label}
      size="small"
      icon={
        config.icon ? (
          <config.icon
            sx={{
              fontSize: 16,
              color: `${config.color} !important`,
            }}
          />
        ) : null
      }
      sx={{
        backgroundColor: config.bg,
        color: config.color,
        fontWeight: 500,
        fontSize: "0.72rem",
        height: 24,
        px: 1,
        border: `1px solid ${config.color}30`,
        ...sx,
      }}
    />
  );
};

export default StatusBadge;
